import {z} from 'zod';
import {
  CreateDocumentRequest,
  CreateReviewRequest,
} from '../../api/generated/index.defs';
import {mapNullToUndefined} from '../../utils/zod';

export const reviewSchema = z.object({
  jobId: z.number(),
  message: z.string(),
  status: z.string(),
  createDocumentRequest: z
    .object({
      jobId: z.number(),
      reviewId: mapNullToUndefined(z.number().optional()),
      codeId: z.number(),
      name: mapNullToUndefined(z.string().optional()),
      url: z.string(),
    })
    .optional() satisfies z.Schema<CreateDocumentRequest | undefined>,
}) satisfies z.Schema<CreateReviewRequest>;
export type ReviewSchema = z.TypeOf<typeof reviewSchema>;
